import React from "react";
import { useSelector } from "react-redux";
import Avatar from "../../form/front/Avatar";
import { useNavigate } from "react-router-dom";

const CompanyCard = () => {
  const { data: profile, loading } = useSelector(
    (state) => state?.profileDetails,
  );
  const navigate = useNavigate();

  if (loading) {
    return <div className="p-4 text-sm text-gray-500">Loading profile...</div>;
  }
  const fullName =
    profile?.firstName && profile?.lastName
      ? `${profile.firstName} ${profile.lastName}`
      : "Unknown User";

  const userEmail = profile?.email || "No email available";
  const bio = profile?.bio;
  const userImage = profile?.image;
  const userCoverImage = profile?.coverMedia;

  // ✅ Clean org
  const orgName = profile?.organization?.name;
  const orgAddress = profile?.organization?.address?.full;
  const handleClick = () => {
    const slug = profile?.uid || profile?._id; // use slug if available
    // navigate(`/profile/${slug}`);
    navigate(`/profile`);
  };

  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-lg cursor-pointer border border-zinc-200 overflow-hidden hover:shadow-md transition"
    >
      <div className="h-16 bg-gray-200 relative">
        {userCoverImage ? (
          <img
            src={userCoverImage}
            alt="cover"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-200" />
        )}

        <div className="absolute -bottom-6 left-4">
          <Avatar
            image={userImage}
            name={fullName.charAt(0)}
            size={60}
            className="border-2 border-white"
          />
        </div>
      </div>

      <div className="pt-8 px-4 pb-4">
        <h3 className="font-semibold text-base text-gray-900">{fullName}</h3>
        {bio && <p className="text-sm text-gray-600 break-all">{bio}</p>}
        <p className="text-sm text-gray-600 break-all">{userEmail}</p>

        <div className="mt-2 text-sm text-gray-700">
          <p className="font-medium">{orgName || "No organization"}</p>

          {orgAddress && (
            <p className="text-xs text-gray-500 mt-1">{orgAddress}</p>
          )}
        </div>
      </div>

      {/* Body */}
      {/* <div className="mt-3 text-gray-700 text-sm font-sans">
        <p>{user?.firstName}, welcome back 👋</p>
        <p className="text-gray-600 mt-1">
          Discover companies and jobs tailored for you.
        </p>
      </div> */}
    </div>
  );
};

export default CompanyCard;
